import { solutions } from "./solutions";
import { softwareItems } from "./software";

export type SearchResult = {
    title: string;
    path: string;
    category: "Solutions" | "Software";
    keywords: string;
};

const normalize = (value: string) =>
    value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

const normalizeCompact = (value: string) =>
    value.toLowerCase().replace(/[^a-z0-9]+/g, "");

export const searchIndex: SearchResult[] = [
    ...solutions.map((item) => ({
        title: item.title,
        path: `/solutions/${item.slug}`,
        category: "Solutions" as const,
        keywords: normalize(`${item.title} ${item.tagline} ${item.slug}`),
    })),
    ...softwareItems.map((item) => ({
        title: item.title,
        path: `/software/${item.slug}`,
        category: "Software" as const,
        keywords: normalize(`${item.title} ${item.tagline} ${item.slug}`),
    })),
];

export const filterSearchResults = (query: string): SearchResult[] => {
    const normalizedQuery = normalize(query);
    const compactQuery = normalizeCompact(query);
    if (!normalizedQuery) {
        return [];
    }

    return searchIndex.filter((item) => {
        const searchableText = `${item.title} ${item.category} ${item.keywords}`;
        const compactText = normalizeCompact(searchableText);

        return (
            normalize(item.title).includes(normalizedQuery) ||
            normalize(item.category).includes(normalizedQuery) ||
            item.keywords.includes(normalizedQuery) ||
            compactText.includes(compactQuery)
        );
    });
};
